import { Form, FormProps, FormValues, UnitType } from '@qfa/forms';
import { UserContext } from 'contexts';
import { useUserTenantPreference } from 'kineticUtils';
import { useContext, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { PREFERENCE_KEYS } from 'types/preferenceTypes';
import ImageUploadField from '../Fields/ImageUploadField';
import { DataSourceProvider } from './DataSources';

interface UnitPreference {
  unit: UnitType;
}

// TODO Make this type safe and generic
function KineticForm<TValue extends FormValues>({
  children,
  externalComponents,
  dataSources = true,
  ...props
}: FormProps<TValue> & { dataSources?: boolean }) {
  const { unit } = useContext(UserContext);
  const { t } = useTranslation('common');

  const { value: preference } = useUserTenantPreference<UnitPreference>({
    key: PREFERENCE_KEYS.UNIT,
  });

  const userUnit = useMemo(() => ({ unit: preference.unit || unit }), [unit, preference.unit]);

  if (!dataSources) {
    return (
      <Form
        {...(props as any)}
        unit={userUnit.unit}
        externalComponents={{
          imageUpload: ImageUploadField,
          ...externalComponents,
        }}
        tErrors={t}
      >
        {children as any}
      </Form>
    );
  }

  return (
    <DataSourceProvider values={props.values}>
      <Form
        {...(props as any)}
        unit={userUnit.unit}
        externalComponents={{
          imageUpload: ImageUploadField,
          ...externalComponents,
        }}
        tErrors={t}
      >
        {children as any}
      </Form>
    </DataSourceProvider>
  );
}

export default KineticForm;
